export {
  default,
  OnboardingTextInput,
  type OnboardingTextInputProps
} from './OnboardingTextField';
